<template>
    <div class="main news-layout">
        <div class="container">
            <article-layout :article="article" :menu="menu"></article-layout>
        </div>
    </div>
</template>

<script>
import DefaultLayout from "../../components/DefaultLayout.vue";
import createHeader from "../../js/meta.js";
import { buildNewsMenu } from "../../js/menu.js";
import ArticleLayout from "../../components/ArticleLayout.vue";

export default {
    components: {
        DefaultLayout,
        ArticleLayout
    },
    async asyncData({ $content, params, error }) {
        try {
            const article = await $content("actu", params.slug).fetch();
            return {
                menu: await buildNewsMenu($content, article.toc),
                article: article
            };
        } catch (e) {
            error({ statusCode: 404, message: "Cette actualité n'existe pas" });
        }
    },
    head() {
        let head = createHeader({
            title: this.article.title,
            description: this.article.description,
            imageUrl: this.article.img
        });

        // add magnific popup script (for zooming images)
        head.script = [
            {
                src:
                    "https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.0.0/jquery.magnific-popup.min.js",
                body: true,
                async: true,
                defer: true
            }
        ];
        head.link = [
            {
                rel: "stylesheet",
                href:
                    "https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.0.0/magnific-popup.css"
            }
        ];

        return head;
    }
};
</script>
